






















import {Component, Vue, Watch} from "vue-property-decorator";
import EnumSelector from "@/shared/components/EnumSelector/index.vue";
import {CommonStatus} from "@/enums/status";
import {RoleStore} from "@/modules/roles/store";
import debounce from "lodash/debounce";
import {RoleParams} from "@/modules/roles/params";
import {RoleType} from "@/enums/type";
import PostOfficeSelector from "@/shared/components/PostOfficeSelector/index.vue";
import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";

@Component({
    name: "RoleSearch",
    components: {PostOfficeSelector, EnumSelector}
})
export default class extends mixins(CommonMixin) {
    CommonStatus = CommonStatus;
    RoleType = RoleType;
    params = new RoleParams();

    @Watch('params', { immediate: false, deep: true })
    onValuesChange(val: any) {
        this.handleChange(val);
    }

    handleChange = debounce(function (val) {
        RoleStore.updateRoleParams(val);
        RoleStore.listRole({ ...val, page: 1 })
    }, 500);
}
